export default __webpack_public_path__ + "static/media/location.f0c117b0.svg";